/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { notification } from "antd";

type NotificationProps = {
  message: string | React.ReactNode;
  description?: string;
};

// Success notification
const openSuccessNotification = (config: NotificationProps): void => {
  notification.success({
    message: config.message,
    description: config.description,
  });
};

// Info notification
const openInfoNotification = (config: NotificationProps): void => {
  notification.info({
    message: config.message,
    description: config.description,
  });
};

// Warning notification
const openWarningNotification = (config: NotificationProps): void => {
  notification.warning({
    message: config.message,
    description: config.description,
  });
};

// Error notification
const openErrorNotification = (config: NotificationProps): void => {
  notification.error({
    message: config.message,
    description: config.description,
  });
};

// Notification controller
export const notificationController = {
  success: openSuccessNotification,
  info: openInfoNotification,
  warning: openWarningNotification,
  error: openErrorNotification,
};
